<template>
  <div class="wrapper">
    <div class="wrap">
      <div class="wrapBg"></div>
      <leftLayout></leftLayout>
      <headerLayout></headerLayout>
      <main>
        <div class="container">
          <div class="main-answer">
            <div class="answer-header">
              <h3 class="title">
                <div class="item">
                  답변 등록
                </div>
              </h3>
            </div>
            <!-- 유형 버전(Class) : typeVersion / 유형 이벤트(Class) : typeEvent / 유형 확인중(Class) : typeChecking -->
            <div class="answer-registration" :class="typeClass(inquire.type)">
              <div class="header">
                <div class="type">
                  <div class="item">
                    {{ findTypeKey(inquire.type) }}
                  </div>
                </div>
                <div class="title">
                  {{ inquire.title }}
                </div>
                <div class="writer">
                  {{ inquire.user_name }} ({{ inquire.user_id }})
                </div>
                <div class="date">
                  {{ inquire.isrt_dt ? inquire.isrt_dt.substring(0,10) : '-' }}
                </div>
              </div>
              <div class="body">
                <div class="view" v-html="replaceNewLine(inquire.content)">
                </div>
                <div class="info answer">
                  <div class="caption answer">
                    <div class="title">
                      답변 여부
                    </div>
                    <div class="content">
                      {{ isAnswered ? '답변완료' : '확인중' }}
                    </div>
                  </div>
                </div>
                <div class="write">
                  <textarea placeholder="내용을 입력하세요." v-model="inquire.reply_content"></textarea>
                </div>
              </div>
            </div>
            <div class="answer-button">
              <button class="list" @click="moveMenu('/CS102?inquire_id=' + inquireId)">
                취소
              </button>
              <!-- 비활성(Attribute) : disabled -->
              <button class="registration" @click="postReply" :disabled="!passValidation">
                등록
              </button>
            </div>
          </div>
        </div>
      </main>
      <footerLayout></footerLayout>
      <div class="alert" :class="{typeConfirm: !confirmType}">
        <div class="container">
          <div class="outer">
            <div class="inner">
              <div class="box">
                <div class="zone">
                  <div class="body" v-html="alertMessage">
                  </div>
                  <div class="footer">
                    <button class="cancel" @click="closeAlert">
                      취소
                    </button>
                    <button class="confirm" @click="confirmAlert">
                      확인
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* Layout */
import LeftLayout from '../layout/Left.vue'
import HeaderLayout from '../layout/Header.vue'
import FooterLayout from '../layout/Footer.vue'
import {csService, settingService} from '../../router'

export default {
  name: 'CS105',
  data () {
    return {
      loading: true,
      inquireId: '',
      inquire: {},
      searchTypeList: [
        {
          key: 'all',
          value: '전체'
        },
        {
          key: 'service',
          value: '서비스'
        },
        {
          key: 'event',
          value: '이벤트'
        },
        {
          key: 'update',
          value: '업데이트'
        }
      ],
      confirmType: false
    }
  },
  created: function () {
  },
  mounted: function () {
    this.inquireId = this.$route.query.inquire_id
    this.setData()
  },
  components: {
    LeftLayout,
    HeaderLayout,
    FooterLayout
  },
  methods: {
    setData: function () {
      csService.getInquireId(this.inquireId).then(response => {
        this.inquire = response.data.inquire
        this.loading = false
      }).catch(error => {
        console.log('getInquireId.err ===>', error)
      })
    },
    findTypeKey (searchType) {
      if (this.searchTypeList.find(it => it.key === searchType) !== undefined) {
        return this.searchTypeList.find(it => it.key === searchType).value
      } else {
        return ''
      }
    },
    typeClass: function (type) {
      let classType = ''
      switch (type) {
        case 'service':
          classType = 'typeChecking'
          break
        case 'update':
          classType = 'typeVersion'
          break
        case 'event':
          classType = 'typeEvent'
          break
      }
      return classType
    },
    postReply: function () {
      this.openConfirm('답변을 등록하면 문의자에게<br>알림이 발송됩니다.<br>이대로 등록하시겠습니까?', function () {
        csService.postInquireReply(this.inquireId, this.inquire.reply_content).then(response => {
          if (response.statusCode === 200) {
            settingService.insertPushAlarm({
              funcId: '7',
              pageId: 'CS-105',
              pageQuery: `?inquire_id=${this.inquireId}`,
              ccodes: [this.inquire.ccode]
            }).then(() => {
              this.openAlert('답변이 등록되었습니다.', function () {
                this.moveMenu('/CS102?inquire_id=' + this.inquireId)
              })
            })
          } else {
            this.openAlert(response.message, null)
          }
        }).catch(error => {
          console.log('postInquireReply.err ===>', error)
        })
      })
    },
    openConfirm: function (html, cb) {
      this.alertMessage = html
      this.alertCallback = cb
      this.confirmType = true
      document.querySelector('body.type-content').classList.add('alertActive')
    },
    confirmAlert: function () {
      document.querySelector('body.type-content.alertActive').classList.remove(`alertActive`)
      this.confirmType = false
      this.alertCallback()
    }
  },
  computed: {
    isAnswered: function () {
      return this.inquire.status === 'completed'
    },
    passValidation: function () {
      return this.inquire.reply_content
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/cs/CS105.vue